import { Tabs, TabsProps } from "antd";
import { PageCard } from "src/common/styles/styles";
import { ContractConfirmationComponent } from "src/features/ServiceContract/CreateServiceContract/ContractConfirmation/ContractConfirmationComponent";
import { useParams } from "react-router";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPayableContractByIdApi } from "../state/action";
import { PayableContractError } from "../state/types";
import { PayableContract } from "src/common/models/payableContract";
import { RootState } from "src/state/reducer";
import { serviceLoading } from "src/common/apiLoader/state/selection";
import { GET_PAYABLE_CONTRACT_BY_ID_API } from "../state/actionTypes";
import InnerLoader from "src/components/InnerLoader";
import { getActivityLogActionLabel, TimeLine } from "src/components/TimeLine";
import { ActivityLog, ActivityLogType } from "src/common/models/activityLog";
import { GET_ACTIVITY_LOG_RECORDS_API } from "src/common/state/actionTypes";
import { formatToDisplayDatetime } from "src/common/util";
import { getActivityLogRecordsApi } from "src/common/state/action";
import { SystemDescriptions } from "src/common/descriptions";
import { PayableContractDebitsComponent } from "../PayableContractDebitsComponent";
import { ContractPaymentComponent } from "src/features/CustomerPayment/ContractPaymentComponent";

interface ReduxProps {
    error?: PayableContractError
    isGettingContract: boolean
    currentContract?: PayableContract
    isGettingActivityLog: boolean
    activityLogs?: ActivityLog[]
}

export const PayableContractDetail = () => {
    const dispatch = useDispatch()

    const { id: payableContractId } = useParams<{ id: string }>();

    const descriptions = SystemDescriptions.PAGES.PAYABLE_CONTRACT.PAYABLE_CONTRACTS

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        error: state?.payableContract.error,
        isGettingContract: serviceLoading(state, [GET_PAYABLE_CONTRACT_BY_ID_API]),
        currentContract: state.payableContract.currentPayableContract,
        isGettingActivityLog: serviceLoading(state, [GET_ACTIVITY_LOG_RECORDS_API]),
        activityLogs: state.common.activityLogs,
    }))

    useEffect(() => {
        if (payableContractId) {
            dispatch(getPayableContractByIdApi(Number(payableContractId)))
            dispatch(getActivityLogRecordsApi({
                ref: payableContractId,
                type: ActivityLogType.PAYABLE_CONTRACT,
            }))
        }
    }, [])

    const items: TabsProps['items'] = [
        {
            key: 'INFO',
            label: descriptions.DATA.TAB_DETAIL,
            children: reduxProps.currentContract
                ? <ContractConfirmationComponent
                    currentContract={reduxProps.currentContract}
                    type={"PAYABLE_CONTRACT"}
                />
                : <InnerLoader />
            ,
        },
        {
            key: 'PAYABLE_CONTRACT_DEBITS',
            label: descriptions.DATA.TAB_PAYABLE_CONTRACT_DEBITS,
            children: <PayableContractDebitsComponent payableContractId={Number(payableContractId)} />
            ,
        },
        {
            key: 'PAYABLE_CONTRACT_PAYMENTS',
            label: descriptions.DATA.TAB_PAYABLE_CONTRACT_PAYMENTS,
            children: <ContractPaymentComponent serviceContractId={Number(payableContractId)} />,
        },
        {
            key: 'ACTIVITY_LOG',
            label: descriptions.DATA.TAB_ACTIVITY_LOG,
            children: reduxProps.activityLogs
                ? <TimeLine
                    records={reduxProps.activityLogs.map(log => {
                        return {
                            description: getActivityLogActionLabel(log.action),
                            date: formatToDisplayDatetime(log.datetime),
                            type: log.action,
                        }
                    })}
                />
                : <InnerLoader />
        },
    ];

    const renderTabs = () => (
        <Tabs defaultActiveKey="INFO" items={items} />
    )

    return (
        < PageCard
            size="small"
            title={descriptions.TITLE}
        >
            {renderTabs()}
        </PageCard>
    )
}
